import { notification } from 'antd'
import {
  createEventUrl,
  listAllEventsUrl,
  deleteEventUrl,
  updateEventUrl
} from '../apis'
import { getToken, customAxios as axios } from '../../../request'
import { hidePageLoad, showPageLoad } from '../../../modules/actions'

/**
 * CREATE NEW EVENT
 */
export const createEventFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let config = {
    ...getToken()
  }
  try {
    let { data } = await axios.post(createEventUrl(), valData, config)
    dispatch(hidePageLoad())
    if (data.success) {
      notification.success({
        message: 'Event created successfully'
      })
    } else if (data.error) {
      notification.error({
        message: data.message || 'Failed to create event'
      })
    }
    return data
  } catch (error) {
    dispatch(hidePageLoad())
    notification.error({
      message: 'Server error encountered during event creation'
    })
    return { success: false, error: true }
  }
}

/**
 * LIST ALL EVENTS (For your Data Table view)
 */
export const listAllEventsAction = (filters) => async (dispatch) => {
  dispatch(showPageLoad())

  let config = {
    params: { ...filters },
    ...getToken()
  }

  try {
    let { data } = await axios.get(listAllEventsUrl(), config)
    dispatch(hidePageLoad())

    if (data.error || data.success === false) {
      notification.error({
        message: data.message || 'Failed to fetch events data'
      })
    }

    return data
  } catch (error) {
    dispatch(hidePageLoad())
    notification.error({
      message: 'Server connectivity dropout while downloading events'
    })
    return { success: false, data: [], total: 0 }
  }
}
export const updateEventFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())

  let config = {
    ...getToken()
  }

  try {
    let { data } = await axios.post(updateEventUrl(), valData, config)
    dispatch(hidePageLoad())

    if (data.success) {
      notification.success({
        message: 'Event updated successfully'
      })
    } else {
      notification.error({
        message: data.message || 'Update failed'
      })
    }

    return data
  } catch (error) {
    dispatch(hidePageLoad())
    notification.error({
      message: 'Server error encountered during event update'
    })
    return { success: false, error: true }
  }
}

/**
 * 🌟 NEW: DELETE AN EVENT
 */
export const deleteEventFxn = (id) => async (dispatch) => {
  dispatch(showPageLoad())

  let config = {
    ...getToken()
  }

  try {
    let { data } = await axios.post(deleteEventUrl(), { id }, config)
    dispatch(hidePageLoad())

    if (data.success) {
      notification.success({
        message: 'Deleted successfully'
      })
    } else {
      notification.error({
        message: data.message || 'Delete failed'
      })
    }

    return data
  } catch (error) {
    dispatch(hidePageLoad())
    notification.error({
      message: 'Server error encountered while deleting event'
    })
    return { success: false, error: true }
  }
}
